<template>
  <section class="team-section">
    <div class="section-container">

      <div class="header">
        <div class="tag">PERSONNEL DATABASE - ACCESS GRANTED</div>
        <h2 class="title">Meet the <span class="gradient">Investigation Team</span></h2>

        <div class="divider-container">
          <div class="line"></div>
          <span class="square-icon">[■]</span>
          <div class="line"></div>
        </div>
      </div>

      <div class="grid">
        <div v-for="agent in agents" :key="agent.id" class="card">
          <span class="corner corner-tl"></span>
          <span class="corner corner-tr"></span>
          <span class="corner corner-bl"></span>
          <span class="corner corner-br"></span>

          <div class="agent-id">AGENT :: {{ agent.id }}</div>

          <div class="avatar-wrap">
            <div class="flow-ring"></div>
            <div class="avatar" :style="{ backgroundImage: `url(${agent.img})` }">
            </div>
            <span class="online-dot"></span>
          </div>

          <h3 class="name">{{ agent.name }}</h3>
          <div class="role">{{ agent.role }}</div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
import img1 from '@/assets/Elazari_hacker_square-1024x1010-1.webp'
import img2 from '@/assets/360_F_493922901_gPyDyy5BvfrDXJd0i5Y5BUYPTNnJzYC3.jpg'
import img3 from '@/assets/images.jpeg'
import img4 from '@/assets/64b00625-ec1f-4e45-832a-bdc622ea354a.769501a4-25c0-4040-bdee-052f1af15f29.webp'
import img5 from '@/assets/agfsdgads.webp'
import img6 from '@/assets/123124.jpeg'
import img7 from '@/assets/rfewqf.jpeg'

export default {
  name: 'TeamSection',
  data() {
    return {
      agents: [
        { id: 'FCD-001', name: 'Michael C. Greene', role: 'SENIOR BLOCKCHAIN ANALYST', img: img1 },
        { id: 'FCD-002', name: 'Mason Brooks', role: 'DIGITAL FORENSICS SPECIALIST', img: img2 },
        { id: 'FCD-003', name: 'Liam Walker', role: 'CYBER INTELLIGENCE ANALYST', img: img3 },
        { id: 'FCD-004', name: 'Noah Mitchell', role: 'CRYPTO INVESTIGATION SPECIALIST', img: img4 },
        { id: 'FCD-005', name: 'James Cooper', role: 'INCIDENT RESPONSE MANAGER', img: img5 },
        { id: 'FCD-006', name: 'Benjamin Hayes', role: 'DIGITAL EVIDENCE ANALYST', img: img6 },
        { id: 'FCD-007', name: 'Daniel Foster', role: 'BLOCKCHAIN INVESTIGATION LEAD', img: img7 },
        { id: 'FCD-008', name: 'Olivia Parker', role: 'CLIENT RELATIONS MANAGER', img: img2 }
      ]
    };
  }
}
</script>

<style scoped>
.team-section {
  background-color: #0a0f1a;
  padding: 80px 5%;
  color: #e2e8f0;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
}

.header {
  margin-bottom: 50px;
}

.tag {
  color: #4fd1c5;
  font-size: 0.75rem;
  letter-spacing: 2px;
  margin-bottom: 10px;
  font-weight: 500;
}

.title {
  font-size: 2.5rem;
  font-weight: 700;
  margin: 0 0 20px;
}

.gradient {
  background: linear-gradient(90deg, #4fd1c5, #8be9fd);
  -webkit-background-clip: text;
  color: transparent;
}

.divider-container {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 10px;
}

.divider-container .line {
  flex: 1;
  height: 1px;
  background-color: rgba(79, 209, 197, 0.2);
}

.divider-container .square-icon {
  color: #4fd1c5;
  font-size: 0.8rem;
  font-family: monospace;
  margin: 0 15px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}

.card {
  position: relative;
  background: #0d1117;
  border: 1px solid rgba(79, 209, 197, 0.15);
  border-radius: 10px;
  padding: 25px 20px;
  text-align: center;
  transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

.card:hover {
  border-color: #4fd1c5;
  transform: translateY(-8px) scale(1.03);
  box-shadow: 0 15px 30px rgba(79, 209, 197, 0.1);
}

.corner {
  position: absolute;
  width: 10px;
  height: 10px;
  border: 2px solid transparent;
  opacity: 0;
  transition: all 0.3s ease;
  pointer-events: none;
}

.corner-tl {
  top: 10px;
  left: 10px;
  border-top-color: #4fd1c5;
  border-left-color: #4fd1c5;
}

.corner-tr {
  top: 10px;
  right: 10px;
  border-top-color: #4fd1c5;
  border-right-color: #4fd1c5;
}

.corner-bl {
  bottom: 10px;
  left: 10px;
  border-bottom-color: #4fd1c5;
  border-left-color: #4fd1c5;
}

.corner-br {
  bottom: 10px;
  right: 10px;
  border-bottom-color: #4fd1c5;
  border-right-color: #4fd1c5;
}

.card:hover .corner {
  opacity: 1;
}

.agent-id {
  font-family: monospace;
  color: #64748b;
  font-size: 0.8rem;
  letter-spacing: 1px;
  margin-bottom: 25px;
  text-align: left;
}

.avatar-wrap {
  position: relative;
  width: 100px;
  height: 100px;
  margin: 0 auto 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.flow-ring {
  position: absolute;
  top: -6px;
  left: -6px;
  right: -6px;
  bottom: -6px;
  border-radius: 50%;
  border: 1px dashed rgba(79, 209, 197, 0.6);
  animation: spin 4s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

.avatar {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  border: 2px solid rgba(139, 233, 253, 0.4);
  background: radial-gradient(circle at 50% 30%, #334155 0%, #0f172a 60%, #000 100%);
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.8);
}

.online-dot {
  position: absolute;
  bottom: 8px;
  right: 8px;
  width: 10px;
  height: 10px;
  background-color: #4fd1c5;
  border-radius: 50%;
  border: 2px solid #0d1117;
  box-shadow: 0 0 8px rgba(79, 209, 197, 0.6);
}

.name {
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0 0 6px;
  color: #fff;
}

.role {
  color: #4fd1c5;
  font-size: 0.75rem;
  font-family: monospace;
  font-weight: 500;
  letter-spacing: 1px;
}


@media (max-width: 1200px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);

  }
}

@media (max-width: 768px) {
  .title {
    font-size: 2rem;
  }

  .grid {
    grid-template-columns: 1fr;
  }
}
</style>